import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from './context/ConfigContext';
import { ConfigLoader } from './components/ConfigLoader';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <ConfigLoader>
        <App />
      </ConfigLoader>
    </ConfigProvider>
  </React.StrictMode>
);
